import { useMutation } from '@tanstack/react-query';

import AuthService, { ViewerDto } from '@/services/AuthService';

export function useAuthViewer() {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (viewerDto: ViewerDto) => AuthService.viewer(viewerDto),
  });

  return {
    authViewer: mutateAsync,
    isLoading: isPending,
  };
}
